var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.73 8 6.5-6.295a1 1 0 0 0 0-1.41 1 1 0 0 0-1.43 0L3.945 6.94a1.5 1.5 0 0 0 0 2.12l6.83 6.65a1.03 1.03 0 0 0 1.43 0 1.001 1.001 0 0 0 0-1.415L5.73 8Z"
  })));
};
export default SvgChevronLeft;